import React from "react";
import { AlertTriangle, CheckCircle, HelpCircle, XCircle } from "lucide-react";
import { LAMBDA_RUN_STATUS } from "./useLambdaRun";

const STATUS_STYLES = {
  [LAMBDA_RUN_STATUS.SUCCESS]: {
    label: "Success",
    className: "bg-green-100 text-green-800",
    Icon: CheckCircle,
  },
  [LAMBDA_RUN_STATUS.WARNING]: {
    label: "Completed with warnings",
    className: "bg-amber-100 text-amber-800",
    Icon: AlertTriangle,
  },
  [LAMBDA_RUN_STATUS.ERROR]: {
    label: "Failed",
    className: "bg-red-100 text-red-800",
    Icon: XCircle,
  },
  [LAMBDA_RUN_STATUS.RUNNING]: {
    label: "Processing",
    className: "bg-blue-100 text-blue-800",
    Icon: null,
  },
  [LAMBDA_RUN_STATUS.UNKNOWN]: {
    label: "Unknown",
    className: "bg-slate-100 text-slate-700",
    Icon: HelpCircle,
  },
};

const formatDuration = (durationMs) => {
  if (!Number.isFinite(durationMs)) return null;
  if (durationMs < 1000) return `${Math.round(durationMs)}ms`;
  return `${(durationMs / 1000).toFixed(1)}s`;
};

const LambdaRunBadge = ({ status, durationMs, label, className = "" }) => {
  const style = STATUS_STYLES[status] || STATUS_STYLES[LAMBDA_RUN_STATUS.UNKNOWN];
  const { Icon } = style;
  const duration = formatDuration(durationMs);

  return (
    <span
      className={`inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full text-xs font-medium ${style.className} ${className}`}
    >
      {Icon ? (
        <Icon className="h-3.5 w-3.5" aria-hidden />
      ) : (
        <span
          className="h-3 w-3 rounded-full border-2 border-current border-t-transparent animate-spin"
          aria-hidden
        />
      )}
      {label || style.label}
      {duration && <span className="opacity-70">· {duration}</span>}
    </span>
  );
};

export default LambdaRunBadge;
